import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Support.css';
import './ReportExtra.css';

export default function ReportProblem() {
  const navigate = useNavigate();
  const [text, setText] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!text.trim()) { alert('Please describe your problem'); return; }
    setText('');
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);
  };

  return (
    <div className="support-page">
      <div className="support-header">
        <div className="container">
          <button className="back-btn" onClick={() => navigate(-1)}>← Back</button>
          <h1>Report a Problem</h1>
        </div>
      </div>

      <div className="container">
        <div className="support-card">
          {submitted && <div className="success-msg">✅ Report submitted! We'll get back to you soon.</div>}
          <form onSubmit={handleSubmit} className="support-form">
            <div className="sf-group">
              <label>Please describe the issue you're facing:</label>
              <textarea rows={8} placeholder="Write your problem here..." value={text}
                onChange={e => setText(e.target.value)} />
            </div>
            <button type="submit" className="btn-submit-report">
              📤 Submit Report
            </button>
          </form>
          <p className="report-note">
            We value your feedback. Our team will review the issue and get back to you as soon as possible.
          </p>
        </div>
      </div>
    </div>
  );
}
